"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.date = void 0;
const date_fns_1 = require("date-fns");
const strftime_1 = __importDefault(require("strftime"));
const chrono_1 = require("../chrono");
const unit_1 = require("../unit");
const value_1 = require("../value");
const w_today = (context) => {
    context.push((0, chrono_1.dateToDateValue)(new Date()));
};
const w_tomorrow = (context) => {
    const tomorrow = (0, date_fns_1.addDays)(new Date(), 1);
    context.push((0, chrono_1.dateToDateValue)(tomorrow));
};
const w_yesterday = (context) => {
    const yesterday = (0, date_fns_1.subDays)(new Date(), 1);
    context.push((0, chrono_1.dateToDateValue)(yesterday));
};
const w_year = (context) => {
    context.pushNumber(context.peekDate().year);
};
const w_month = (context) => {
    context.pushMonth(context.peekDate().month);
};
const w_day = (context) => {
    context.pushNumber(context.peekDate().day);
};
const w_weekday = (context) => {
    const date = (0, chrono_1.dateValueToDate)(context.peekDate());
    context.pushWeekday(date.getDay());
};
const w_dayOfYear = (context) => {
    const date = (0, chrono_1.dateValueToDate)(context.peekDate());
    context.pushNumber((0, date_fns_1.getDayOfYear)(date));
};
const w_daysInMonth = (context) => {
    const date = (0, chrono_1.dateValueToDate)(context.peekDate());
    context.pushNumber((0, date_fns_1.getDaysInMonth)(date));
};
const w_daysInYear = (context) => {
    const date = (0, chrono_1.dateValueToDate)(context.peekDate());
    context.pushNumber((0, date_fns_1.getDaysInYear)(date));
};
const w_isLeapYear = (context) => {
    const date = (0, chrono_1.dateValueToDate)(context.peekDate());
    context.pushBoolean((0, date_fns_1.isLeapYear)(date));
};
const w_format = (context) => {
    const value = context.popDate();
    const date = (0, chrono_1.dateValueToDate)(value);
    const formatString = context.popString();
    context.pushString((0, strftime_1.default)(formatString, date));
};
const w_toNumber = (context) => {
    const value = context.popDate();
    const date = (0, chrono_1.dateValueToDate)(value);
    context.pushNumber((0, date_fns_1.getUnixTime)(date), unit_1.units.second);
};
const w_toVector = (context) => {
    const value = context.popDate();
    context.pushVector([
        (0, value_1.newNumberValue)(value.year),
        (0, value_1.newMonthValue)(value.month),
        (0, value_1.newNumberValue)(value.day),
    ]);
};
exports.date = [
    ["today", w_today],
    ["tomorrow", w_tomorrow],
    ["yesterday", w_yesterday],
    ["date:year", w_year],
    ["date:month", w_month],
    ["date:day", w_day],
    ["date:weekday", w_weekday],
    ["date:day-of-year", w_dayOfYear],
    ["date:days-in-month", w_daysInMonth],
    ["date:days-in-year", w_daysInYear],
    ["date:leap-year?", w_isLeapYear],
    ["date:format", w_format],
    ["date:>number", w_toNumber],
    ["date:>vector", w_toVector],
];
